const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

class SodUgcRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.sod-ugc__track');
    this.cards = Array.from(this.querySelectorAll('.sod-ugc-card'));
    this.arrows = Array.from(this.querySelectorAll('[data-scroll]'));

    if (!this.track) return;

    this.arrows.forEach((a) => a.addEventListener('click', this.onArrow));
    this.track.addEventListener('scroll', this.syncArrows, { passive: true });
    this.syncArrows();

    this.querySelectorAll('[data-sound]').forEach((b) => b.addEventListener('click', this.onSound));

    if (!REDUCED_MOTION.matches) {
      this.observer = new IntersectionObserver(this.onIntersect, { threshold: 0.5 });
      this.cards.forEach((c) => c.querySelector('video') && this.observer.observe(c));
    }
  }

  disconnectedCallback() {
    this.arrows.forEach((a) => a.removeEventListener('click', this.onArrow));
    this.track?.removeEventListener('scroll', this.syncArrows);
    this.querySelectorAll('[data-sound]').forEach((b) => b.removeEventListener('click', this.onSound));
    this.observer?.disconnect();
  }

  onArrow = (event) => {
    const direction = Number(event.currentTarget.dataset.scroll) || 1;
    const card = this.cards[0];
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const step = (card?.getBoundingClientRect().width || this.track.clientWidth) + gap;
    this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
  };

  syncArrows = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const max = scrollWidth - clientWidth - 1;
    this.arrows.forEach((a) => {
      const forward = Number(a.dataset.scroll) > 0;
      a.toggleAttribute('disabled', forward ? scrollLeft >= max : scrollLeft <= 0);
    });
  };

  onIntersect = (entries) => {
    entries.forEach((entry) => {
      const video = entry.target.querySelector('video');
      if (!video) return;
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  };

  onSound = (event) => {
    const button = event.currentTarget;
    const card = button.closest('.sod-ugc-card');
    const video = card?.querySelector('video');
    if (!video) return;

    const unmute = video.muted;
    if (unmute) {
      this.cards.forEach((other) => {
        if (other === card) return;
        const v = other.querySelector('video');
        if (v) v.muted = true;
        other.querySelector('[data-sound]')?.setAttribute('aria-pressed', 'false');
      });
    }

    video.muted = !unmute;
    button.setAttribute('aria-pressed', String(unmute));
    const soundLabel = unmute ? button.dataset.labelMute : button.dataset.labelUnmute;
    if (soundLabel) button.setAttribute('aria-label', soundLabel);
    if (unmute) video.play().catch(() => {});
  };
}

if (!customElements.get('sod-ugc-rail')) {
  customElements.define('sod-ugc-rail', SodUgcRail);
}
